import React, { useCallback, useContext, useMemo } from "react";
import { IFunctionalLocation, IFunctionalLocationsProps } from "../FailureDetailsInterfaces";
import { HMIContext } from "../../../../../../contexts/HMIContext/HMIContext";
import { FailureDetailsButton } from "../../../../../../components/FailureDetailsButton/FailureDetailsButton.view";
import { useStyles } from "../FailureDetails.styles";
import { Grid } from "@mui/material";
import { setCurrentFunctionalLocation } from "../../../../../../utilities/storageUtilities";
import { handleNameTranslation } from "utilities/localesUtilities";
import { useTranslation } from "react-i18next";

export const FailureFunctionalLocationsButtons = ({ functionalLocations }: IFunctionalLocationsProps) => {
    const { handleFunctionalLocation, handleNextFailureDetailsStep } = useContext(HMIContext);
    const classes = useStyles();
    const { i18n } = useTranslation();

    const handleFailureFunctionalLocation = useCallback(
        (functionalLocation: IFunctionalLocation) => {
            return (event: React.MouseEvent) => {
                event.preventDefault();
                handleFunctionalLocation(functionalLocation);
                setCurrentFunctionalLocation(functionalLocation);
                handleNextFailureDetailsStep();
            };
        },
        [handleFunctionalLocation, handleNextFailureDetailsStep],
    );

    const translatedButtonsNames = useMemo(
        () =>
            functionalLocations.map((functionalLocation) => (
                <Grid item xs={5.8} key={functionalLocation.functional_location_id}>
                    <FailureDetailsButton
                        onClick={handleFailureFunctionalLocation(functionalLocation)}
                        name={handleNameTranslation(
                            i18n.language.slice(0, 2),
                            functionalLocation.translation.translation_names,
                        )}
                    />
                </Grid>
            )),
        [i18n.language, functionalLocations, handleFailureFunctionalLocation],
    );

    return (
        <Grid container className={classes.failureButtonsContainer}>
            {translatedButtonsNames}
        </Grid>
    );
};
